/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as ImportRouteImport } from './routes/import'
import { Route as GoalsRouteImport } from './routes/goals'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as BudgetsRouteImport } from './routes/budgets'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as IndexRouteImport } from './routes/index'

const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRoute = ImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsRoute = GoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsRoute = BudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/chat': typeof ChatRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/chat': typeof ChatRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/chat': typeof ChatRoute
  '/goals': typeof GoalsRoute
  '/import': typeof ImportRoute
  '/insights': typeof InsightsRoute
  '/login': typeof LoginRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alerts'
    | '/budgets'
    | '/categories'
    | '/chat'
    | '/goals'
    | '/import'
    | '/insights'
    | '/login'
    | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts'
    | '/budgets'
    | '/categories'
    | '/chat'
    | '/goals'
    | '/import'
    | '/insights'
    | '/login'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/alerts'
    | '/budgets'
    | '/categories'
    | '/chat'
    | '/goals'
    | '/import'
    | '/insights'
    | '/login'
    | '/transactions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertsRoute: typeof AlertsRoute
  BudgetsRoute: typeof BudgetsRoute
  CategoriesRoute: typeof CategoriesRoute
  ChatRoute: typeof ChatRoute
  GoalsRoute: typeof GoalsRoute
  ImportRoute: typeof ImportRoute
  InsightsRoute: typeof InsightsRoute
  LoginRoute: typeof LoginRoute
  TransactionsRoute: typeof TransactionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals': {
      id: '/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof GoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets': {
      id: '/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof BudgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertsRoute: AlertsRoute,
  BudgetsRoute: BudgetsRoute,
  CategoriesRoute: CategoriesRoute,
  ChatRoute: ChatRoute,
  GoalsRoute: GoalsRoute,
  ImportRoute: ImportRoute,
  InsightsRoute: InsightsRoute,
  LoginRoute: LoginRoute,
  TransactionsRoute: TransactionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
